import { render } from "./videoUploader.vue?vue&type=template&id=288805e3"
import script from "./videoUploader.vue?vue&type=script&lang=js"
export * from "./videoUploader.vue?vue&type=script&lang=js"

import "./videoUploader.vue?vue&type=style&index=0&id=288805e3&lang=scss"

import exportComponent from "D:\\_laravelProjects\\2sport\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__